import { render, staticRenderFns } from "./StockMomentum.vue?vue&type=template&id=828064b2&scoped=true"
import script from "./StockMomentum.vue?vue&type=script&lang=js"
export * from "./StockMomentum.vue?vue&type=script&lang=js"
import style0 from "./StockMomentum.vue?vue&type=style&index=0&id=828064b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "828064b2",
  null
  
)

export default component.exports